export default __webpack_public_path__ + "static/covered-4e72b34a612f794180ed8cf1ee61d436.png";